(function(){
  "use strict";
  var s=document.createElement("style");
  s.textContent=".bundle-selector{max-width:100%;margin:16px 0}.bundle-option{display:flex;align-items:center;gap:12px;padding:14px 12px;border:1px solid #e0e0e0;cursor:pointer;transition:all .15s}.bundle-option:first-child{border-radius:8px 8px 0 0}.bundle-option:last-child{border-radius:0 0 8px 8px}.bundle-option:not(:first-child){border-top:none}.bundle-option.selected{border:2px solid #FCD116!important;background:#FFFDE6}.bundle-option input[type=radio]{width:18px;height:18px;accent-color:#FCD116;flex-shrink:0}.bundle-option .b-info{flex:1}.bundle-option .b-info .b-title{font-weight:600!important;font-size:14px!important;margin:0}.bundle-option .b-info .b-save{font-size:12px!important;color:#009B3A!important;margin:2px 0 0;font-weight:500!important}.bundle-option .b-price{text-align:right;position:relative}.bundle-option .b-price .b-old{font-size:12px!important;color:#999!important;text-decoration:line-through;margin:0}.bundle-option .b-price .b-new{font-weight:600!important;font-size:15px!important;margin:0}.bundle-badge{position:absolute;top:-12px;right:0;background:#CE1126;color:#fff!important;font-size:10px!important;font-weight:600!important;padding:3px 8px;border-radius:4px;white-space:nowrap}.bundle-ship-info{text-align:center;font-size:12px!important;color:#009B3A!important;margin:8px 0 0}";
  document.head.appendChild(s);

  function fmt(n){ return n.toFixed(2).replace(".",",") + "\u20ac"; }

  function initBundle(){
    if(!window.location.pathname.match(/\/products\//)) return;

    var variantSelects = document.querySelector("variant-selects");
    if(!variantSelects) return;

    var sel = variantSelects.querySelector("select");
    if(!sel || sel.options.length < 2) return;

    if(sel.name.indexOf("Quantit") < 0) return;

    if(!window.ShopifyAnalytics || !ShopifyAnalytics.meta || !ShopifyAnalytics.meta.product) return;

    var p = ShopifyAnalytics.meta.product;
    var vs = p.variants;
    if(!vs || vs.length < 2) return;

    var bp = vs[0].price / 100;
    var vd = vs.map(function(v, i){
      var pr = v.price / 100;
      var q = i + 1;
      return { id: v.id, title: v.public_title || v.name, price: pr, up: pr / q, dc: Math.round((1 - pr / q / bp) * 100) };
    });

    variantSelects.style.display = "none";

    var w = document.createElement("div");
    w.className = "bundle-selector";

    vd.forEach(function(v, i){
      var o = document.createElement("label");
      o.className = "bundle-option" + (i === vd.length - 1 ? " selected" : "");
      var htm = '<input type="radio" name="bundle-qty" value="' + v.id + '"' + (i === vd.length - 1 ? " checked" : "") + '>';
      htm += '<div class="b-info"><p class="b-title">' + v.title + '</p>';
      if(i === 0){
        htm += '<p class="b-save" style="color:#888!important">Prix standard</p>';
      } else {
        htm += '<p class="b-save">Vous \u00e9conomisez ' + v.dc + '%</p>';
      }
      htm += '</div><div class="b-price" style="position:relative">';
      if(i === vd.length - 1) htm += '<span class="bundle-badge">Le plus vendu</span>';
      if(i > 0) htm += '<p class="b-old">' + fmt(bp) + '</p>';
      htm += '<p class="b-new">' + fmt(v.up) + '</p></div>';
      o.innerHTML = htm;
      w.appendChild(o);
    });

    variantSelects.parentNode.insertBefore(w, variantSelects);

    var si = document.createElement("p");
    si.className = "bundle-ship-info";
    si.textContent = "Exp\u00e9dition en 24-48h";
    w.after(si);

    w.addEventListener("change", function(e){
      if(!e.target.matches('input[name="bundle-qty"]')) return;
      var sid = e.target.value;
      w.querySelectorAll(".bundle-option").forEach(function(o){ o.classList.remove("selected"); });
      e.target.closest(".bundle-option").classList.add("selected");

      var vData = vd.find(function(v){ return String(v.id) === String(sid); });
      if(vData){
        for(var j = 0; j < sel.options.length; j++){
          if(sel.options[j].text.trim() === vData.title.trim()){
            sel.selectedIndex = j;
            sel.dispatchEvent(new Event("change", { bubbles: true }));
            break;
          }
        }
      }
      document.querySelectorAll('input[name="id"]').forEach(function(h){ h.value = sid; });
    });

    var lv = vd[vd.length - 1];
    var r = w.querySelector('input[value="' + lv.id + '"]');
    if(r){ r.checked = true; r.dispatchEvent(new Event("change", { bubbles: true })); }
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", function(){ setTimeout(initBundle, 800); });
  } else {
    setTimeout(initBundle, 800);
  }
})();